import script from "./login-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-form.vue?vue&type=script&lang=ts&setup=true"

import "./login-form.vue?vue&type=style&index=0&id=9295ddca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9295ddca"]])

export default __exports__